/* ==========================================================================
   10 REASONS ADVERTORIAL — JAVASCRIPT
   Peaksta · Slim Carry 2
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {

  /* ── Dynamic date (2 days ago) ── */
  var MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var d = new Date();
  d.setDate(d.getDate() - 2);
  document.querySelectorAll('.js-tenr-date').forEach(function (el) {
    el.textContent = MONTHS[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
  });

  /* ── Footer year ── */
  document.querySelectorAll('.js-tenr-year').forEach(function (el) {
    el.textContent = new Date().getFullYear();
  });

  /* ── Nav shadow on scroll ── */
  var nav = document.querySelector('.tenr-nav');
  if (nav) {
    function checkNav() { nav.classList.toggle('shadow', window.scrollY > 30); }
    window.addEventListener('scroll', checkNav, { passive: true });
    checkNav();
  }

  /* ── FAQ accordion (single open) ── */
  document.querySelectorAll('.tenr-faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = this.closest('.tenr-faq');
      var wasOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.tenr-faq').forEach(function (f) {
        f.classList.remove('open');
        var a = f.querySelector('.tenr-faq-q');
        if (a) a.setAttribute('aria-expanded', 'false');
      });

      // Toggle current
      if (!wasOpen) {
        item.classList.add('open');
        this.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Floating mobile CTA ── */
  var floatEl = document.querySelector('.tenr-float');
  var heroEl = document.querySelector('.tenr-hero');
  if (floatEl && heroEl) {
    function checkFloat() {
      var pastHero = heroEl.getBoundingClientRect().bottom < 0;
      floatEl.classList.toggle('show', pastHero);
    }
    window.addEventListener('scroll', checkFloat, { passive: true });
    checkFloat();
  }

  /* ── Intersection Observer fade-in ── */
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    document.querySelectorAll('.tenr-fade').forEach(function (el) {
      observer.observe(el);
    });
  } else {
    // Fallback: show all immediately
    document.querySelectorAll('.tenr-fade').forEach(function (el) {
      el.classList.add('visible');
    });
  }

  /* ── Smooth scroll for anchor links ── */
  document.querySelectorAll('.tenr-wrap a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
